import { ReactComponent as BMI } from './bmi.svg';
import { ReactComponent as Calculator } from './calculator.svg';
import { ReactComponent as Database } from './database.svg';
import { ReactComponent as HeartRate } from './heart-rate.svg';
import { ReactComponent as Info } from './info.svg';
import { ReactComponent as LabResults } from './lab-results.svg';
import { ReactComponent as Medications } from './medications.svg';
import { ReactComponent as Metrics } from './metrics.svg';
import { ReactComponent as Radiology } from './radiology.svg';
import { ReactComponent as Sort } from './sort-icon.svg';
import { ReactComponent as TableView } from './table-view.svg';
import { ReactComponent as Vitals } from './vitals.svg';
import { ReactComponent as StatusDot } from './status-dot.svg';

export const icons = {
    BMI,
    Calculator,
    Database,
    HeartRate,
    Info,
    LabResults,
    Medications,
    Metrics,
    Radiology,
    Sort,
    TableView,
    Vitals,
    StatusDot,
};
